export default "<div class=\"navbar-wrap\">\r\n  <ng-content></ng-content>\r\n</div>\r\n"